import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export default function LoaderPrincipalMain() {
  return (
    <div className="loader-main">
      <Box className="box-loading-main">
        <Stack className="skeleton" spacing={1}>
          {[...Array(4)].map((_, index) => (
            <React.Fragment key={index}>
              <Skeleton variant="text" width={index === 0 ? '20%' : '100%'} height={50} />
              <Skeleton variant="rectangular" width={index === 0 ? '20%' : '100%'} height={50} />
            </React.Fragment>
          ))}
        </Stack>
      </Box>
    </div>
  );
}
